exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-service[data-v-592d5672] {\n    /* Add your component styles here */\n}\n", ""]);

// exports
